import request from '.';

export default function realNameVerification(data) {

    return request({
        url: 'v1/contractCenter/realNameVerification',
        method: 'post',
        data,
    });
}
